import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {

  },

  getters: {

  },

  mutations: {

  },

  actions: {
    onSearch: ({ commit }, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'M0701TagService.onSearch', input: payload }]
      }).then(data => {
        commit('SET_ROWS', data[0].output.data)
        commit('SET_PAGINATION', data[0].output.pagination)
      })
    },
    searchTag: ({ commit }, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'M0701TagService.searchTag', input: payload }]
      }).then(data => {
        commit('SET_ROWS', data[0].output)
      })
    },
    add: (ctx, payload) => {
      return ApiUtils.postData({
        data: [{ api: 'M0701TagService.addTag', input: payload }]
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
